"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../..");

var _mobxReact = require("mobx-react");

var _helpers = require("../../_helpers/helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./AmountRow.css");

var _styles = {
  "amount": "AmountRow__amount___30pUt",
  "amount-value": "AmountRow__amount-value___3Hrwa"
};

const styles = _bind.default.bind(_styles);

const AmountRow = (0, _mobxReact.observer)(({
  className,
  amountCent,
  amountLabel = 'Amount balance',
  dataTestId,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('amount'), className);
  return _react.default.createElement(_.Content, {
    flex: true,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8,
    paddingTopBottom: 16,
    paddingLeftRight: 24,
    className: composed_classname,
    dataTestId: dataTestId,
    ...props
  }, _react.default.createElement(_.Text, {
    text: amountLabel
  }), _react.default.createElement(_.Text, {
    text: (0, _helpers.CentsToDisplayString)(amountCent || 0),
    variant: 'medium',
    className: styles('amount-value')
  }));
});
var _default = AmountRow;
exports.default = _default;